import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '@mui/material/Typography';
import { formatCurrency, parseCurrency } from '@mcn-platform/models';
const ItemPrice = ({ variant, price, sellPrice, }) => {
    // original price is the price field unless its missing or
    // zero then use the sellPrice.
    let originalPrice = price;
    if (!originalPrice || parseCurrency(originalPrice) === 0) {
        originalPrice = sellPrice;
    }
    // final price is the sell price if present
    // if sellPrice is zero,
    // or missing or greater than the original price
    // use the originalPrice
    let finalPrice = sellPrice || originalPrice;
    if (finalPrice && originalPrice
        && parseCurrency(finalPrice) > parseCurrency(originalPrice)) {
        finalPrice = originalPrice;
    }
    if (finalPrice && parseCurrency(finalPrice) === 0) {
        finalPrice = originalPrice;
    }
    // if we dont have a sellprice, dont show pricing at all
    if (!finalPrice || parseCurrency(finalPrice) === 0) {
        return null;
    }
    const showStrikeThrough = (originalPrice && finalPrice)
        && originalPrice !== finalPrice;
    return (_jsxs(Typography, { component: "div", variant: "h5", fontWeight: "fontWeightBold", sx: {
            textAlign: 'center',
            // minWidth: 134,
            paddingX: 1,
            mx: 1,
            mt: 1,
            lineHeight: 1.75,
            flexGrow: 1,
            ...(variant === 'outlined' && {
                border: (theme) => `2px solid ${theme.palette.dividerSecondary}`,
                borderRadius: 3.5,
            }),
        }, children: [showStrikeThrough && (_jsx(Typography, { component: sellPrice ? 's' : 'span', variant: "inherit", fontWeight: "inherit", sx: {
                    ...(sellPrice && { color: (theme) => theme.palette.error.main }),
                }, children: formatCurrency(originalPrice) })), _jsxs(Typography, { component: "span", variant: "inherit", fontWeight: "inherit", className: "finalPrice", children: ["\u00A0\u00A0", formatCurrency(finalPrice)] })] }));
};
ItemPrice.defaultProps = {
    variant: 'text',
    sellPrice: undefined,
};
export default ItemPrice;
//# sourceMappingURL=ItemPrice.js.map